import { useListDatasetsQuery } from "lib/types/graphql";
import { isExecutionDisabled } from "lib/datasets/deprecation";

export function useGetIsDatasetIdExecutable() {
  const datasetsRes = useListDatasetsQuery();

  return function getIsDatasetIdExecutable(datasetId: number) {
    const dataset = datasetsRes.data?.datasets.find((dataset) => {
      return dataset.id === datasetId;
    });

    return dataset && !isExecutionDisabled(dataset);
  };
}
